import { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';

import axios, { axiosClassic } from '../../api/intercepors';
import { getAuthUrl } from '../../config/url.config';
import {
  IAuthResponseData,
  IUserProfile,
} from '../../store/user/user.interface';

import { removeTokensStorage } from './auth.helps';

export const AuthService = {
  async register(
    phone_or_email: string,
    action: 'register_user_with_temp_pwd' | 'send_user_temp_pwd'
  ) {
    const response = await axiosClassic.post<IAuthResponseData>(
      getAuthUrl('/users'),
      {
        phone_or_email,
        action,
      }
    );
    return response;
  },
  async login(
    phone_or_email: string,
    password: string,
    is_one_time_password: boolean = true
  ) {
    const response = await axiosClassic.post<
      IUserProfile,
      AxiosResponse<IAuthResponseData>
    >(getAuthUrl('/login'), {
      phone_or_email,
      password,
      is_one_time_password,
    });

    return response;
  },
  async logout() {
    const sessionToken = localStorage.getItem('st');
    const response = await axiosClassic.post(
      getAuthUrl('/logout'),
      {},
      {
        headers: {
          'session-token': String(sessionToken),
        },
      }
    );
    removeTokensStorage();
    
    //Это уже не актуально ('user' нету в localstorage), но удалим старые данные
    localStorage.removeItem('user');
    
    return response;
  },

  //Проверка сессии пользователя
  async checkLogin() {
    const sessionToken = localStorage.getItem('st');
    const response = await axiosClassic.post<IAuthResponseData>(
      getAuthUrl('/check-login'),
      {},
      {
        headers: {
          'session-token': String(sessionToken),
        },
      }
    );
    return response;
  },
};
